/**
 * 全局提示弹窗：标题固定为「提示」。
 * 用于替代原生 alert()（原生弹窗标题为英文 Alert，体验差且不可控）。
 * 用法：组件内 this.$alert('消息内容')；非组件环境 import appAlert 后直接调用。
 */
let maskEl = null

const STYLE_ID = 'app-alert-style'
const STYLE_CSS = `
.app-alert-mask {
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: app-alert-fade 0.2s ease;
}
.app-alert-box {
  width: calc(620 * var(--w));
  background: #fff;
  border-radius: calc(16 * var(--w));
  overflow: hidden;
}
.app-alert-title {
  padding: calc(48 * var(--w)) calc(48 * var(--w)) 0;
  text-align: center;
  font-size: calc(40 * var(--w));
  font-weight: 500;
  color: #323233;
  line-height: 1.5;
}
.app-alert-message {
  padding: calc(24 * var(--w)) calc(48 * var(--w)) calc(48 * var(--w));
  text-align: center;
  font-size: calc(36 * var(--w));
  color: #646566;
  line-height: 1.5;
  white-space: pre-line;
  word-break: break-all;
}
.app-alert-btns {
  display: flex;
  border-top: 1px solid #f0f0f0;
}
.app-alert-btn {
  flex: 1;
  height: calc(96 * var(--w));
  font-size: calc(36 * var(--w));
  border: none;
  background: #fff;
  color: #2E8CF6;
  cursor: pointer;
  font-family: inherit;
}
.app-alert-btn:active {
  background: #f5f5f5;
}
@keyframes app-alert-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}
`

function ensureStyle() {
  if (document.getElementById(STYLE_ID)) return
  const style = document.createElement('style')
  style.id = STYLE_ID
  style.textContent = STYLE_CSS
  document.head.appendChild(style)
}

function closeAlert() {
  if (maskEl && maskEl.parentNode) {
    maskEl.parentNode.removeChild(maskEl)
  }
  maskEl = null
}

export default function appAlert(message) {
  closeAlert()
  ensureStyle()

  maskEl = document.createElement('div')
  maskEl.className = 'app-alert-mask'
  maskEl.innerHTML =
    '<div class="app-alert-box">' +
    '  <div class="app-alert-title">提示</div>' +
    '  <div class="app-alert-message"></div>' +
    '  <div class="app-alert-btns">' +
    '    <button class="app-alert-btn" type="button">确定</button>' +
    '  </div>' +
    '</div>'
  maskEl.querySelector('.app-alert-message').textContent = String(message)
  maskEl.querySelector('.app-alert-btn').addEventListener('click', closeAlert)
  document.body.appendChild(maskEl)
}



// WEBPACK FOOTER //
// ./src/utils/appAlert.js